const getNameInitials = (name: string): string => {
  const nameArray = name?.split(' ');
  const firstName = nameArray?.[0];
  const lastName =
    nameArray?.length > 1 ? nameArray?.[nameArray?.length - 1] : '';
  const firstInitial = firstName?.charAt(0);
  const lastInitial = lastName ? lastName.charAt(0) : '';
  const initials = `${firstInitial}${lastInitial}`.toUpperCase();
  return initials;
};

export default getNameInitials;
